import { useNavigate } from "react-router-dom";
import { createRecordCommand } from "../../../api/api-hooks/conversations/useUpdateGPTConversations.ts/createRecordCommand";
import { CreateRecordResponse } from "../GPTConvoTypes";
import { BrieMessageBody, BrieMessageHeader } from "./SearchMessage";
import useView from "../../../api/api-hooks/views/useView";

interface Props {
  message: CreateRecordResponse;
}

export default function CreateRecordMessage({ message }: Props) {
  const navigate = useNavigate();
  const { view } = useView({
    pageID: message?.PageID,
    viewID: message?.ViewID,
  });

  return (
    <div>
      <BrieMessageHeader title="Create Record Command" />
      <BrieMessageBody
        onClick={handleCreateRecord}
        message={message?.Message}
      />
    </div>
  );

  function handleCreateRecord() {
    createRecordCommand({
      message,
      navigate,
      prefills: view?.Prefills || [],
      setCreateRecord: undefined,
      setPrefill: undefined,
    });
  }
}
